A code describing the severity of the PositionNotPostedReason. This is intended to help the UI present different reasons consistently through appropriate visual treatments.

Currently, three codes are defined:

- `info` indicates an informational state.
- `warning` indicates a state that may require attention.
- `error` indicates a failure state that requires investigation or remediation.
